var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
/**
 * A stateless toolbar button. This button does not have any internal state. It listens to clicks and calls the onClick handler.
 */
export var ToolbarButtonStateless = function (props) {
    var _a, _b;
    var label = props.label, ariaLabel = props.ariaLabel, icon = props.icon, onClick = props.onClick, disabled = props.disabled, testId = props.testId;
    return (_jsxs("button", __assign({ onClick: function () {
            onClick && onClick();
        }, title: (_b = (_a = props.title) !== null && _a !== void 0 ? _a : label) !== null && _b !== void 0 ? _b : ariaLabel, "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label, className: classNames("toolbar-button", { disabled: disabled }, { labeled: label != null }), disabled: disabled, "data-testid": testId }, { children: [icon, label && _jsx("div", __assign({ className: "toolbar-button-label" }, { children: label }))] })));
};
